'use strict';

require('./chunk-e6d921c6.js');
var _fold = require('./_fold.js');
var _get = require('./_get.js');

/**
 * Returns true if `a` is a function.
 *
 * @private
 */
function isFunction(a) {
  return a instanceof Function;
}

function groupBy(f, as) {
  var iteratee = function iteratee(a) {
    return isFunction(f) ? f(a) : _get(f, a);
  };

  return _fold(function (memo, a) {
    var key = iteratee(a);
    (memo[key] = memo[key] || []).push(a);
    return memo;
  }, {}, as);
}

module.exports = groupBy;
